export const PRODUCT_LINE = "Review what changed. Fix what drifted. Remember every decision.";

export const DECISION_REVIEW_INTRO = "RenderRepo reviews what this pull request changes about your product.";

export const FINDING_DISCLAIMER =
  "These are possible product decisions detected in this pull request. They are not confirmed product truth.";

export const PUBLICATION_PERMISSION =
  "The review completed, but RenderRepo needs GitHub Checks permission to publish it on the pull request.";

export const PUBLICATION_REAUTHORIZE =
  "Review completed. Reauthorize the RenderRepo GitHub App with Checks permission to publish this result on GitHub.";

export const REVIEWS_WORK_WITHOUT_CHECKS =
  "Reviews work now. Reauthorize the RenderRepo GitHub App with Checks permission to publish results on GitHub.";

export const CORRECTION_INTRO = "Turn this finding into a bounded plan for Cursor or Claude Code.";

export const AUTHORIZATION_BOUNDARY = "A person must approve the plan before an agent can begin work.";

export const CORRECTION_DRAFT_LABEL = "Draft — not yet saved or authorized.";

export const ALREADY_REVIEWED = "This commit has already been reviewed.";

export const UNCONFIRMED_LABEL = "Unconfirmed observation";

export const SESSION_NOTE = "Recorded on this page only. This does not change the saved review.";
